// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1sXXN","imageUploader":"EGiftCard_imageUploader__1UsrK"};